import { useEffect, useRef, useState } from "react";
import { siteData } from "@/store/siteData";

export default function CTASection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const cta = siteData.getCTA();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const el = document.getElementById("iletisim");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section ref={ref} className="relative overflow-hidden bg-[#F1F5F9] py-28">
      <div className="absolute inset-0">
        <img src="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1920&q=80" alt="" className="w-full h-full object-cover object-center opacity-10" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F1F5F9] via-[#F1F5F9]/80 to-[#F1F5F9]"></div>
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className={`max-w-3xl mx-auto text-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#3B82F6]"></div>
            <span className="text-[#334155] text-xs font-semibold tracking-[0.3em] uppercase">{cta.tag}</span>
            <div className="h-px w-12 bg-[#3B82F6]"></div>
          </div>
          <h2 className="text-[#0F172A] font-black uppercase mb-5" style={{ fontSize: "clamp(28px, 4.5vw, 60px)", letterSpacing: "-0.02em", lineHeight: "1.1" }}>
            {cta.title}
          </h2>
          <p className="text-[#64748B] text-base leading-relaxed mb-10 max-w-xl mx-auto">{cta.subtitle}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={scrollToContact} className="whitespace-nowrap inline-flex items-center gap-3 bg-[#3B82F6] text-white px-10 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#2563EB] transition-colors duration-300 cursor-pointer">
              {cta.cta1Text}
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-base"></i></div>
            </button>
            <a href="#iletisim" onClick={(e) => { e.preventDefault(); scrollToContact(); }} className="whitespace-nowrap inline-flex items-center gap-3 border border-[#E2E8F0] text-[#334155] px-10 py-4 text-sm font-bold tracking-widest uppercase hover:border-[#3B82F6] hover:text-[#0F172A] transition-all duration-300 cursor-pointer">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line text-base"></i></div>
              {cta.cta2Text}
            </a>
          </div>
          <div className={`flex flex-wrap items-center justify-center gap-8 mt-14 pt-10 border-t border-[#E2E8F0] transition-all duration-700 delay-300 ${visible ? "opacity-100" : "opacity-0"}`}>
            {cta.trustItems.map((item, i) => (
              <div key={i} className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center"><i className={`${item.icon} text-[#3B82F6] text-base`}></i></div>
                <span className="text-[#64748B] text-xs tracking-wide">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
